// app/frontend/channels/consumer.js
import { createConsumer } from "@rails/actioncable"

// Keep authenticated vendor streams on the host serving the current page.
// This avoids sending a Dapple/Pinball session through another host's cable
// endpoint when the same Rails app is mounted at /cable on every surface.
export default createConsumer("/cable")
